<template>
  <div style="background-color: #f0f0f0;">
    <HeaderView :title="$t('mine.pointshistory')" />
    <div class="view-page">
      <van-pull-refresh
        :pulling-text="$t('common.repulling')"
        :loosing-text="$t('common.reloosing')"
        :loading-text="$t('common.reloading')"
        :success-text="$t('common.resuccess')"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />
        <div v-else class="jfdetail">
          <van-cell v-for="(v, key) in list" :key="key">
            <template #title>
              <div class="box">
                <div class="left">₹</div>
                <div>
                  <p>{{ v.scene }}</p>
                  <span class="sp1">{{ v.time_text }}</span>
                </div>
              </div>
            </template>
            <template #default>
              <span v-if="v.money.indexOf('-') != -1" style="color: rgb(245, 105, 105)">{{ v.money_text }}</span>
              <span v-else style="color: rgb(60, 209, 151)"> {{ v.money_text }}</span>
            </template>
          </van-cell>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import HeaderView from "../../components/Header/index.vue";
export default {
  name: "PoninsHistoryView",
  components: { HeaderView },
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: "get",
        url: "trade",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
          console.log(this.list);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>
<style lang="scss">
.jfdetail {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
}

.jfdetail .van-cell {
  margin-bottom: 0.5rem;
}

.jfdetail .van-cell:before {
  display: none;
}

.jfdetail .van-cell-group {
  width: 100%;
  margin: 0.5rem auto;
  background: none;
}

.jfdetail .van-cell__value {
  color: #f26060;
  font-size: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: 600;
  flex: auto;
}

.jfdetail .van-cell__title {
  width: 80%;
  flex: auto;
  display: flex;
  flex-direction: column;
}

.jfdetail .van-cell__title .box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.jfdetail .van-cell__title .box .left {
  width: 2.5rem;
  height: 2.5rem;
  background: #f16290;
  margin-right: 10px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
}

.jfdetail .van-cell__title p {
  font-weight: 600;
}

.jfdetail .van-cell__title .sp1 {
  font-size: 0.7rem;
}

.jfdetail .van-cell__title .sp2 {
  color: #9c91c0 !important;
}
</style>
